import styled from 'styled-components';
import { COLORS, FONTS, SIZE, FONT_SIZE } from '@app/src/ui';

interface Props {
  color: string;
}

export const Item = styled.li`
  overflow: hidden;
  position: relative;
  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.BLACK_BOLD};
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    border-radius: 6px;
    border: 1px solid ${COLORS.BLACK_BOLD};
    margin-bottom: 10px;
  }
`;

export const Title = styled.h3`
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  font-size: 16px;
  max-width: 90%;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Day = styled.span`
  font-size: ${FONT_SIZE.SHORT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  color: ${COLORS.GRAY_DARK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Price = styled.span`
  font-weight: 600;
`;

export const TabItem = styled.div`
  position: relative;
  cursor: pointer;
  min-height: 58px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 16px;
`;

export const IconWrapper = styled.span`
  position: absolute;
  top: 50%;
  right: 17px;
  transform: translateY(-50%);
  svg {
    transform: rotate(-90deg);
  }
`;

export const Counter = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background: ${(props: Props) => props.color};
  color: #fff;
  font-size: 9px;
  font-family: ${FONTS.OPEN_SANS};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  & ~ svg {
    margin-left: 6px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 24px;
    height: 24px;
  }
`;

export const Summary = styled.div`
  background: ${COLORS.WHITE_DARK};
  position: relative;
  margin: 0;
  padding: 23px 36px 24px 20px;
`;

export const Publications = styled.h4`
  color: ${COLORS.GRAY_DARK};
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 10px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

export const Description = styled.span`
  color: #333;
  font-family: ${FONTS.OPEN_SANS};
  font-size: 11px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  span:not(:first-child) {
    &:before {
      content: ',';
      margin-right: 4px;
    }
  }
`;

export const IconTrash = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  width: 36px;
  height: 100%;
  background: ${COLORS.GRAY};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Subtotal = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 10px;
  text-align: right;
  margin-top: 4px;
  margin-right: 21px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;
  }
`;

export const SubtotalPrice = styled.span`
  display: block;
  font-weight: 600;
  font-size: 16px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Available = styled.span`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLUE_LINK};
  font-size: 14px;
  font-weight: 400;
`;
